import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faSort, faSortUp, faSortDown, faHeart, faLink, faBars, faHandshake, faCar,
  faCarBattery, faSackDollar, faChargingStation, faStar, faHelmetSafety, faListUl,
  faMoneyBill, faTree, faCarSide, faBus, faBicycle, faSolarPanel, faBatteryThreeQuarters,
  faTemperatureLow, faWater, faKitchenSet, faHouse, faMobileScreenButton, faTriangleExclamation,
  faBolt, faWrench, faPerson, faChartSimple, faGear, faLocationDot, faCircleInfo, faCalculator,
  faGasPump, faLeaf, faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import {
  faHeart as faHeartO,
  faCircleXmark as faCircleXmarkO,
  faCompass,
} from '@fortawesome/free-regular-svg-icons';
import VueApexCharts from 'vue-apexcharts';
// Lazy load images - used with v-lazy to cut down on Imagin api calls and page load time.
import VueLazyload from 'vue-lazyload';

import Vue from 'vue';

import {
  BootstrapVue, IconsPlugin, DropdownPlugin, CarouselPlugin,
} from 'bootstrap-vue';

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Used by Dealership Map
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster'; // replace src with dist if you have Babel issues

import App from './App.vue';
import router from './router';
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// Vue.use(LayoutPlugin);
// Vue.use(ModalPlugin);
// Vue.use(CardPlugin);
// Vue.use(VBScrollspyPlugin);
Vue.use(DropdownPlugin);
// Vue.use(TablePlugin);
Vue.use(CarouselPlugin);

/* eslint-disable */
Vue.use(VueApexCharts);

Vue.use(VueLazyload);

// // Options for Vue Lazy Load error and default images (above is default):
// const loadimage = require('./assets/loading.gif')
// const errorimage = require('./assets/error.gif')

// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: errorimage,
//   loading: loadimage,
//   attempt: 1
// })

// Used by DealershipMap
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCaxM621WE0aEekFznWmNB6_mxo7ersMOs',
    libraries: 'places', // OR: libraries: 'places,drawing,visualization'
  },
  installComponents: true,
});
Vue.component('GmapCluster', GmapCluster);

Vue.component('apex-chart', VueApexCharts);

Vue.config.productionTip = false;

library.add(faLink);
library.add(faSort);
library.add(faSortUp);
library.add(faSortDown);
library.add(faHeart);
library.add(faHeartO);
library.add(faBars);
library.add(faHandshake);
library.add(faCar);
library.add(faStar);
library.add(faCarBattery);
library.add(faSackDollar);
library.add(faChargingStation);
library.add(faHelmetSafety);
library.add(faListUl);
library.add(faMoneyBill);
library.add(faTree);
library.add(faCarSide);
library.add(faBus);
library.add(faBicycle);
library.add(faSolarPanel);
library.add(faBatteryThreeQuarters);
library.add(faTemperatureLow);
library.add(faWater);
library.add(faKitchenSet);
library.add(faHouse);
library.add(faMobileScreenButton);
library.add(faTriangleExclamation);
library.add(faBolt);
library.add(faWrench);
library.add(faPerson);
library.add(faChartSimple);
library.add(faGear);
library.add(faLocationDot);
library.add(faCircleInfo);
library.add(faCalculator);
library.add(faCircleXmarkO);
library.add(faCompass);
library.add(faGasPump);
library.add(faLeaf);
library.add(faMagnifyingGlass);


Vue.component('font-awesome-icon', FontAwesomeIcon);

/*
The following Vue.filter functions can be used in templates with piping to format numbers for display.
E.g. proper commas, decimal places, dollar signs at the beginning, etc.
Also used for logging, like booleanYesNo, to display something human readable for non tech people.
*/
Vue.filter('booleanYesNo', (value) => {
  if (value) return 'Yes';
  return 'No';
});

// Two decimal places, commas every 3 digits
Vue.filter('numberTwoDecimal', (value) => {
  if (!value) return '0';
  return parseFloat(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
});
// One decimal places, commas every 3 digits
Vue.filter('numberOneDecimal', (value) => {
  if (!value) return '0';
  return parseFloat(value).toLocaleString('en', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
});
// Add commas, integer
Vue.filter('numberWhole', (value) => {
  if (!value) return '0';
  return parseInt(value, 10).toLocaleString('en');
});
// Two decimal places, commas every 3 digits, dollar sign in front
Vue.filter('currencyUSD', (value) => {
  if (!value) return '$0';
  return `$${parseFloat(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
});
// Commas every 3 digits, dollar sign in front
Vue.filter('currencyUSDWhole', (value) => {
  if (!value) return '$0';
  return `$${parseInt(value, 10).toLocaleString('en')}`;
});

// Used in conjunction with screen size checks to determine if mobile nav dropdown should be displayed
// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
function mobileCheck() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

// Used to construct urls for logging and requesting data from backend.
Vue.prototype.$baseUrl = window.location.origin.includes('localhost') ? 'http://127.0.0.1:8000' : window.location.origin;
// Below defaults to charged-staging for backend when local serving below. Swap to above to use local server.
// Vue.prototype.$baseUrl = window.location.origin.includes('localhost') ? 'https://charged-staging.herokuapp.com' : window.location.origin;
Vue.prototype.$mobile = mobileCheck();

// Utility function for logging to backend. Also logs to Google Analytics via gtag.
// There might be a good reason why the code here is a helper function and not in the mixin method itself.
// If I recall correctly, axios was weird about it.
import axios from 'axios';
function logMessage(level, message_key, message_value) {
  // Logs to backend python app
  axios.post(`${Vue.prototype.$baseUrl}/api/log`, {
      level: level,
      message_key: message_key,
      message_value: message_value
  });
}

// Utility methods for changing route/opening links in new tab and logging
Vue.mixin({
  methods: {
    changeRoute(route) {
      // console.log(route, typeof route); 
      // Handles: regular web links, email links, and then defaults to internal router link
      if (route.includes('@')) {
        window.open(route, '_self');
      }
      if (route.includes('mailto')) {
        window.open(route, '_self');
      } else if (typeof route == 'string') {
        // Handle urls missing https absolute prefix. Just append. Otherwise they open in current base path.
        if (!route.startsWith('https://') && !route.startsWith('https://')) {
          route = `https://${route}`;
        }
        window.open(route, '_blank');
      } else {
        this.$router.push(route);
      }
    },
    logMessage(level, message_key, message_value) {
      // Logs to Google Analytics. See router for configuration.
      // https://developers.google.com/analytics/devguides/collection/gtagjs/events
      // https://matteo-gabriele.gitbook.io/vue-gtag/v/master/methods/events
      // console.log(this.$gtag);
      this.$gtag.event(message_key, { // message_key = action
        'event_category': document.URL, // Using URL for category to support segmenting by client/page
        'event_label': message_value, // Label = value
      });
      logMessage(level, message_key, message_value)
    },
  }
})

// Works with App.vue to handle browser resizing. Primarily used for switching from nav bar to dropdown when width is small
Vue.directive('resize', {
  inserted: function(el, binding) {
    const onResizeCallback = binding.value;
    window.addEventListener('resize', () => {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      onResizeCallback({ width, height });
    })
  }
});
Vue.prototype.$globalObservableData = Vue.observable({
  width: document.documentElement.clientWidth,
  height: document.documentElement.clientHeight,
  showNavDropown: Vue.prototype.$mobile || document.documentElement.clientWidth < 1000,
});

// Logs site navigation
router.beforeEach((to, from, next) => { 
  // console.log(document.URL);
  logMessage('info', 'Page Load', document.URL);
  next();
  // Deafualt behavior with router is to maintain page scrolling.
  // This is weird, so instead scroll to the top after changing pages.
  // Default scroll behavior is "smooth" animation, so instead use instant jump
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  });
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
